import React, { useState } from 'react';
import RTModal from '../common/RTModal';
import RTButton from '../common/RTButton';
import { formatDateToDDMMYYYY } from '../../utils/dateHelper';
import { apiPost } from '../../api/apiClient';
import { toastSuccess, toastError } from '../common/toast';
import './RevokeNoticeModal.css';

const RevokeNoticeModal = ({ 
  isOpen, 
  onClose, 
  allocation, 
  onSuccess 
}) => {
  const [loading, setLoading] = useState(false);

  // Calculate remaining days from today to end date
  const getRemainingDays = () => {
    if (!allocation?.end_date) return 0;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = new Date(allocation.end_date);
    endDate.setHours(0, 0, 0, 0);
    
    const timeDifference = endDate.getTime() - today.getTime();
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    
    return Math.max(0, daysDifference);
  };

  const handleRevert = async () => {
    try {
      setLoading(true);

      const updateData = {
        notice_date: null,
        end_date: null
      };

      const response = await apiPost(`/allocation/update/${allocation.allocation_id}`, updateData);
      
      if (response.status === 200) {
        toastSuccess(`Notice to vacate revoked successfully for ${allocation.pg_name}`);
        onSuccess(); // Refresh the data in parent component
        onClose(); // Close modal
      }
    } catch (error) {
      console.error('Error revoking notice to vacate:', error);
      toastError(error.response?.data?.detail || 'Failed to revoke notice to vacate');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const footer = (
    <>
      <RTButton
        variant="secondary"
        onClick={handleCancel}
        disabled={loading}
      >
        Cancel
      </RTButton>
      <RTButton
        variant="primary"
        onClick={handleRevert}
        disabled={loading}
      >
        {loading ? 'Processing...' : 'Revert Notice'}
      </RTButton>
    </>
  );

  return (
    <RTModal
      isOpen={isOpen}
      onClose={handleCancel}
      title="Revoke Notice To Vacate"
      footer={footer}
      size="medium"
    >
      <div className="revoke-notice-modal-content">
        <div className="revoke-confirmation-message">
            <div className="confirmation-icon">⚠️</div>
            <div className="confirmation-text">
              <p>
                Revoking this notice will allow the paying guest to continue their tenancy indefinitely.
              </p>
            </div>
          </div>
        <div className="revoke-notice-info">
          <h4>Allocation Details</h4>
          <div className="revoke-notice-info-grid">
            <div className="revoke-notice-info-item">
              <label>PG Name:</label>
              <span>{allocation?.pg_name || 'N/A'}</span>
            </div>
            <div className="revoke-notice-info-item">
              <label>Building:</label>
              <span>{allocation?.building_name || 'N/A'}</span>
            </div>
            <div className="revoke-notice-info-item">
              <label>Room:</label>
              <span>{allocation?.room_name || 'N/A'}</span>
            </div>
            <div className="revoke-notice-info-item">
              <label>Current Rent:</label>
              <span>₹{allocation?.rent_amount?.toLocaleString() || 'N/A'}</span>
            </div>
          </div>
        </div>

        <div className="current-notice-info">
          <h4>Current Notice Information</h4>
          
          <div className="current-notice-summary">
            <div className="summary-item">
              <strong>Notice Date:</strong> {allocation?.notice_date ? formatDateToDDMMYYYY(allocation.notice_date) : 'N/A'}
            </div>
            <div className="summary-item">
              <strong>Current End Date:</strong> {allocation?.end_date ? formatDateToDDMMYYYY(allocation.end_date) : 'N/A'}
            </div>
            <div className="summary-item">
              <strong>Days Left:</strong> {getRemainingDays()} days
            </div>
          </div>

          
        </div>
      </div>
    </RTModal>
  );
};

export default RevokeNoticeModal;
